import { render, staticRenderFns } from "./cybscansione.vue?vue&type=template&id=23690aa3&"
import script from "./cybscansione.vue?vue&type=script&lang=js&"
export * from "./cybscansione.vue?vue&type=script&lang=js&"
import style0 from "./cybscansione.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports